import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class GolfHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="golf"
      title="Golf Betting Tips & Leaderboards"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Golf/containers/GolfHomePage.js